var _dec, _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { FalsyFC, FalsyText } from "../../devsupport";
import { styled } from "../../theme";
export
/**
 * TopNavigation provides a heading component for the entire page.
 *
 * @extends React.Component
 *
 * @property {ReactText | (TextProps) => ReactElement} title - String, number or a function component
 * to render within the top navigation.
 * If it is a function, expected to return a Text.
 *
 * @property {ReactText | (TextProps) => ReactElement} subtitle - String, number or a function component
 * to render within the top navigation.
 * If it is a function, expected to return a Text.
 *
 * @property {() => ReactElement} accessoryLeft - Function component
 * to render to the left edge the top navigation.
 *
 * @property {() => ReactElement} accessoryRight - Function component
 * to render to the right edge the top navigation.
 *
 * @property {string} appearance - Appearance of the component.
 * Can be `default`, `control`.
 * Use *control* appearance when needed to display within a contrast container.
 *
 * @property {string} alignment - Alignment of nested components.
 * Can be `center` or `start`.
 * Defaults to *start*.
 *
 * @property {ViewProps} ...ViewProps - Any props applied to View component.
 *
 * @overview-example TopNavigationSimpleUsage
 * In basic example TopNavigation contains a title and actions.
 *
 * @overview-example TopNavigationAccessories
 * TopNavigation may contain a single action on the left,
 * and as many actions as needed on the right. In common practices, actions may be wrapped in menus.
 *
 * @overview-example TopNavigationDivider
 * It is a good idea to separate TopNavigation and screen contents with `Divider` component.
 *
 * @overview-example TopNavigationImageTitle
 * Sometimes it is needed to have an image as title.
 * In this case, a function component can be provided to `title` property.
 *
 * @overview-example TopNavigationStyling
 * TopNavigation and it's inner views can be styled by passing them as function components.
 *
 * In most cases, this is redundant, if [custom theme is configured](guides/branding).
 * ```
 * import { TopNavigation, Text } from '../..';
 *
 * <TopNavigation
 *   title={evaProps => <Text {...evaProps}>Title</Text>}
 *   subtitle={evaProps => <Text {...evaProps}>Subtitle</Text>}
 * />
 * ```
 */
let TopNavigation = (_dec = styled('TopNavigation'), _dec(_class = (_temp = class TopNavigation extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getAlignmentDependentStyles", alignment => {
      if (alignment === 'center') {
        return {
          container: styles.containerCentered,
          titleContainer: styles.titleContainerCentered
        };
      }

      return {
        rightControlsContainer: styles.rightControlsContainerStart
      };
    });

    _defineProperty(this, "getComponentStyle", source => {
      const {
        titleTextAlign,
        titleFontFamily,
        titleFontSize,
        titleFontWeight,
        titleColor,
        subtitleTextAlign,
        subtitleFontFamily,
        subtitleFontSize,
        subtitleFontWeight,
        subtitleColor
      } = source,
            containerParameters = _objectWithoutProperties(source, ["titleTextAlign", "titleFontFamily", "titleFontSize", "titleFontWeight", "titleColor", "subtitleTextAlign", "subtitleFontFamily", "subtitleFontSize", "subtitleFontWeight", "subtitleColor"]);

      return {
        container: containerParameters,
        title: {
          textAlign: titleTextAlign,
          fontFamily: titleFontFamily,
          fontSize: titleFontSize,
          fontWeight: titleFontWeight,
          color: titleColor
        },
        subtitle: {
          textAlign: subtitleTextAlign,
          fontFamily: subtitleFontFamily,
          fontSize: subtitleFontSize,
          color: subtitleColor,
          fontWeight: subtitleFontWeight
        }
      };
    });
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      style,
      title,
      subtitle,
      alignment,
      accessoryLeft,
      accessoryRight
    } = _this$props,
          viewProps = _objectWithoutProperties(_this$props, ["eva", "style", "title", "subtitle", "alignment", "accessoryLeft", "accessoryRight"]);

    const evaStyles = this.getComponentStyle(eva.style);
    const alignmentStyles = this.getAlignmentDependentStyles(alignment);
    return /*#__PURE__*/React.createElement(View, _extends({
      style: [evaStyles.container, styles.container, alignmentStyles.container, style]
    }, viewProps), /*#__PURE__*/React.createElement(View, {
      style: styles.leftControlContainer
    }, /*#__PURE__*/React.createElement(FalsyFC, {
      component: accessoryLeft
    })), /*#__PURE__*/React.createElement(View, {
      style: alignmentStyles.titleContainer
    }, /*#__PURE__*/React.createElement(FalsyText, {
      style: evaStyles.title,
      component: title
    }), /*#__PURE__*/React.createElement(FalsyText, {
      style: evaStyles.subtitle,
      component: subtitle
    })), /*#__PURE__*/React.createElement(View, {
      style: [styles.rightControlsContainer, alignmentStyles.rightControlsContainer]
    }, /*#__PURE__*/React.createElement(FalsyFC, {
      component: accessoryRight
    })));
  }

}, _temp)) || _class);
const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  containerCentered: {
    justifyContent: 'space-between'
  },
  titleContainerCentered: _objectSpread(_objectSpread({}, StyleSheet.absoluteFillObject), {}, {
    justifyContent: 'center',
    alignItems: 'center'
  }),
  leftControlContainer: {
    flexDirection: 'row',
    zIndex: 1
  },
  rightControlsContainer: {
    flexDirection: 'row',
    zIndex: 1
  },
  rightControlsContainerStart: {
    flex: 1,
    justifyContent: 'flex-end'
  }
});